import React, {useMemo} from 'react';
import {useDispatch} from 'react-redux';
import {useTable, usePagination, useFilters} from 'react-table';
import {Table, Button, Dropdown, Input} from 'semantic-ui-react';
import {invoicesPageSizes} from '../../../common/constants/lists';
import {Filter, DefaultColumnFilter} from './TableFilters';
import {Actions} from '../../../common/actions';

const {updateStateServiceForm} = Actions;

const statusOptions = [
  {'value': 'published', 'text': 'PUBLICADO'},
  {'value': 'pin_progress', 'text': 'EN PROGRESO'},
];

const MantainTable = ({forms, filters}) => {
  const dispatch = useDispatch();
  const flattenData = forms.map((element) => ({
    ...element,
    ...element.answers,
    ...element.generalInfo,
  }));

  function onChangeSelectState(event, row) {
    const {index, original} = row;
    const id = original._id.$oid;
    const data = forms.slice();
    const copy = Object.assign({}, data[index]);
    copy.status = copy.status === 'published' ? 'in_progress' : 'published';
    data[index] = copy;
    dispatch(
      updateStateServiceForm(id, {'status': data[index].status}, filters)
    );
  }

  const columnsTable = [
    {
      'Header': 'ID',
      'accessor': 'formNumber',
    },
    {
      'Header': 'TĪTULO',
      'accessor': 'title',
      'Cell': ({row}) => row.original.title.toUpperCase(),
    },
    {
      'Header': 'CAUSA DEL PROBLEMA',
      'accessor': 'cause_of_the_problem',
      'Cell': ({row}) => row.original.cause_of_the_problem.toUpperCase(),
    },
    {
      'Header': 'FECHA',
      'accessor': 'createdDate',
    },
    {
      'Header': 'FECHA DE REPARACIÓN',
      'accessor': 'repairOfDate',
      'Cell': ({row}) => {
        const {repairOfDate} = row.original;
        return repairOfDate || null;
      },
    },
    {
      'Header': 'RESPONSABLE',
      'accessor': 'responsible',
      'Cell': ({row}) => {
        const {responsible} = row.original;
        return responsible || null;
      },
    },
    {
      'Header': 'USUARIO',
      'accessor': 'user',
      'Cell': ({row}) => {
        const {user} = row.original;
        return user || null;
      },
    },
    {
      'Header': 'TIPO',
      'accessor': 'type',
    },
    {
      'Header': 'ESTADO',
      'accessor': 'status',
      'Cell': ({row}) => {
        const status = row.original.status;
        return (
          <Dropdown
            className='select-vehicles-maintain'
            value={status}
            options={statusOptions}
            onChange={(e) => onChangeSelectState(e, row)}
          />
        );
      },
      'disableFilters': true,
    },
  ];

  const data = useMemo(() => flattenData, []);
  const columns = useMemo(() => columnsTable, []);
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    canPreviousPage,
    canNextPage,
    pageOptions,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    'state': {pageIndex, pageSize},
  } = useTable(
    {
      columns,
      data,
      'defaultColumn': {'Filter': DefaultColumnFilter},
      'initialState': {'pageIndex': 0, 'pageSize': 10},
    },
    useFilters,
    usePagination
  );

  return (
    <Table
      compact
      striped
      className='interactive -striped -highlight twc-table'
      {...getTableProps()}
    >
      <Table.Header>
        {headerGroups.map((headerGroup) => (
          <Table.Row key='headers' {...headerGroup.getHeaderGroupProps()}>
            {headerGroup.headers.map((column, index) => (
              <Table.HeaderCell
                key={`title-${index}`}
                textAlign='center'
                {...column.getHeaderProps()}
              >
                {column.render('Header')}
              </Table.HeaderCell>
            ))}
          </Table.Row>
        ))}
        {headerGroups.map((headerGroup) => (
          <Table.Row key='filters' id='filters'>
            {headerGroup.headers.map((column, index) => (
              <Table.HeaderCell key={`filter-${index}`} textAlign='center'>
                <Filter column={column} />
              </Table.HeaderCell>
            ))}
          </Table.Row>
        ))}
      </Table.Header>
      <Table.Body {...getTableBodyProps()}>
        {!page.length && (
          <Table.Row>
            <Table.Cell colSpan={10} textAlign='center'>
              No hay datos disponibles
            </Table.Cell>
          </Table.Row>
        )}
        {page.length > 0 &&
          page.map((row, i) => {
            prepareRow(row);
            return (
              <Table.Row {...row.getRowProps()}>
                {row.cells.map((cell) => {
                  return (
                    <Table.Cell textAlign='center' {...cell.getCellProps()}>
                      {cell.render('Cell')}
                    </Table.Cell>
                  );
                })}
              </Table.Row>
            );
          })}
      </Table.Body>
      {page.length > 0 && (
        <Table.Footer>
          <Table.Row>
            <Table.HeaderCell colSpan={1} textAlign='left'>
              <Button
                className='navigation-button'
                color='blue'
                onClick={() => previousPage()}
                disabled={!canPreviousPage}
                content='Anterior'
              />
            </Table.HeaderCell>
            <Table.HeaderCell colSpan={3} textAlign='right'>
              <span>páginas </span>
              <span>
                <Input
                  type='number'
                  min='1'
                  max={pageOptions.length}
                  value={pageIndex + 1}
                  onChange={(e, {value}) => {
                    const page = value ? Number(value) - 1 : 0;
                    if (page < 1 || page > pageOptions.length) {
                      e.target.value = 1;
                    }
                    gotoPage(page);
                  }}
                />
              </span>{' '}
              <span>de {pageOptions.length}</span>
            </Table.HeaderCell>
            <Table.HeaderCell colSpan={4} textAlign='left'>
              <Dropdown
                className='filter-selection'
                selection
                upward
                compact
                value={pageSize}
                options={invoicesPageSizes}
                onChange={(e, {value}) => {
                  setPageSize(Number(value));
                }}
              />
              <span>{' '}filas</span>
            </Table.HeaderCell>
            <Table.HeaderCell colSpan={1} textAlign='right'>
              <Button
                className='navigation-button'
                color='blue'
                onClick={() => nextPage()}
                disabled={!canNextPage}
                content='Siguiente'
              />
            </Table.HeaderCell>
          </Table.Row>
        </Table.Footer>
      )}
    </Table>
  );
};

export default MantainTable;
